<template>
<v-dialog v-model="show" max-width="600">
  <template v-slot:activator="{on}">
    <slot name="activator" :on="on"></slot>
  </template>
  <v-card :loading="loading">
    <CardTitle title="Samples waiting on emails" dense>
      <template v-slot:actions>
        <v-btn @click="show = false" icon ><v-icon>mdi-close</v-icon></v-btn>
      </template>
    </CardTitle>
    <v-card-text>
      <div v-if="loading" class="title text-center">loading...</div>
      <div v-if="samples.length === 0 && !loading" class="title text-center">Nothing to email</div>
      <v-card v-for="(customer, customer_id) in customers" :key="customer_id" dense >
        <CardTitle :title="customer" dense></CardTitle>
        <v-card-text>
          <v-simple-table >
            <tbody>
              <tr v-for="sample in samples.filter(s => s.customer_id.toString() === customer_id.toString())" :key="sample.uuid">
                <td><ReleaseSampleV2 :sample="sample"></ReleaseSampleV2></td>
                <td>{{sample.id}}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
import Recorded from "@/Lib/Recorded";
export default {
  name: "WaitingToBeEmailedDialog",
  components: {
    ReleaseSampleV2: () => import('./ReleaseSampleV2'),
  },
  data: () => ({
    show: false,
    loading: false,
    samples: [],
    customers: {},
  }),
  watch: {
    show(v){
      if(v){
        this.loadSamples();
      } else {
        this.samples = [];
        this.customers = {};
      }
    }
  },
  computed: {
    samplesAwaitingEmail() {
      return Object.keys(this.$store.state.ReleaseSampleStore.samplesAwaitingEmail);
    },
    samplesProcessing() {
      return Object.keys(this.$store.state.ReleaseSampleStore.samplesProcessing);
    },
    samplesFailed() {
      return Object.keys(this.$store.state.ReleaseSampleStore.samplesFailed);
    },
    uniqueCustomerIds() {
      if(this.samples.length === 0) return [];
      return [...new Set(this.samples.map(s => s.customer_id))];
    },
  },
  mounted() {
  },
  methods: {
    async loadSamples(){
      this.loading = true;
      const sampleUuids = [...this.samplesAwaitingEmail, ...this.samplesProcessing, ...this.samplesFailed]
      if(sampleUuids.length === 0) {
        this.loading = false;
        return;
      }
      const query = await Recorded.get('/query', {
        table: 'samples',
        select: ['*'],
        where: [
          {column: 'uuid', operator:'IN', value: sampleUuids},
        ]
      });
      this.samples = query.data;
      await this.loadCustomerNames()
      this.loading = false;
    },
    async loadCustomerNames(){
      if(this.uniqueCustomerIds.length === 0) return;
      const query = await this.$store.$db().model('customers').api().fetch({
        with: 'primaryName',
        where_in: {
          key: 'id',
          values: this.uniqueCustomerIds,
        }
      }, "", null, false, false);
      console.log(query, 'CUSTOMERS QUERY');
      query.response.data.forEach(customer => {
        this.customers[customer.id] = customer.primary_name ? customer.primary_name.name : 'Unknown';
      });
    },
    removeFromEmailingList(uuid){
      this.$firestore.collection('release_sample').doc(uuid).update({
        email_sent: true,
      })
      this.loadSamples();
    }
  }
}
</script>

<style scoped>

</style>
